export function counterText(textarea) {
  let counter = document.getElementById("textarea_counter");

  counter.textContent = textarea.value.length + "/160";

  if (textarea.value.length > 160) {
    textarea.value = textarea.value.substring(0, 160);  
  }
}
